/* eslint-disable */
import Header from "components/Common/Header/Header";
import EventFeedbackGivenBody from "components/EventComponents/EventDetailsComponents/EventFeedbackComponents/FeedbackGiven/EventFeedbackGivenBody";

const EventFeedbackGiven = () => {
  return (
    <main id="app">
      {/* ---- header start ---- */}
      <Header moduleName="events" />
      {/* --- header end --- */}

      <EventFeedbackGivenBody />
    </main>
  );
};

export default EventFeedbackGiven;
